// version_poller.js
// Polls /api/v1/app_version every 60s.
// When the server version changes, reloads the tab.
//
// Safe reload rules:
//   - Never interrupt active typing (INPUT/TEXTAREA focused)
//   - Never interrupt queued offline ops (_90mod_opq)
//   - If blocked, sets pendingUpdate = true and retries on:
//       · input blur
//       · page visibility change (tab refocused)
//       · next poll interval (if no longer blocked)

(function () {
  const POLL_MS  = 60_000;
  const ENDPOINT = '/api/v1/app_version';

  let bootVersion   = null;
  let pendingUpdate = false;

  async function fetchVersion() {
    try {
      const res = await fetch(ENDPOINT, { cache: 'no-store' });
      if (!res.ok) return null;
      const { version } = await res.json();
      return version;
    } catch {
      return null;
    }
  }

  function isBlocked() {
    const active = document.activeElement;
    const typing = active && ['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName) && !active.readOnly;
    const hasQueuedOps = (() => {
      try { return JSON.parse(localStorage.getItem('_90mod_opq') || '[]').length > 0; } catch { return false; }
    })();
    return typing || hasQueuedOps;
  }

  function reloadWhenSafe() {
    if (!pendingUpdate) return;
    if (isBlocked()) return;
    window.location.reload();
  }

  function triggerUpdate(newVersion) {
    // Fire event so update_notifier.js can show the banner
    document.dispatchEvent(new CustomEvent('mod:version-update', {
      detail: { version: newVersion }
    }));

    if (isBlocked()) {
      pendingUpdate = true;
    } else {
      // On mobile / PWA show the banner instead of silent reload
      const isMobilePWA = window.matchMedia('(display-mode: standalone)').matches ||
                          /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (!isMobilePWA) {
        window.location.reload();
      }
      // On mobile/PWA: let the banner drive the reload (tap to update)
    }
  }

  async function init() {
    bootVersion = await fetchVersion();

    // Poll every 60s
    setInterval(async () => {
      const current = await fetchVersion();
      if (current && bootVersion && current !== bootVersion) {
        triggerUpdate(current);
      }
      // Retry if a previous update was deferred
      reloadWhenSafe();
    }, POLL_MS);

    // Retry on input blur (user finished typing)
    document.addEventListener('blur', reloadWhenSafe, true);

    // Retry when user switches back to the tab
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) reloadWhenSafe();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
